import React from 'react';
import { Modal } from '@/components/AntD';
import './index.scss';

export default function PackageServiceModal({ open, setOpen }) {

  return <Modal
    title=""
    centered
    open={open}
    className="PackageServiceModal"
    onCancel={() => setOpen(false)}
    width={940}
    footer={null}
  >
    <h3>需要专人帮助配音? 扫描二维码详询客服</h3>
    <img className="qrcode" src="https://oss.5rs.me/oss/uploadfe/png/c19521ebb988bf27fab95d59489249b9.png" />
    <img className="bottom-img" src="https://oss.5rs.me/oss/uploadfe/png/8c7471b55e9d599c8cace66e356e2140.png" />
  </Modal>;
}